import { ClientStoreType } from '@modernanimal/common/src/shared/flows/onboarding/store';

const getCompletionRoute = (client?: Pick<ClientStoreType, 'id'> | null) => (
    client?.id ? 'download-app' : null
);

export default getCompletionRoute;
